module.exports = __webpack_public_path__ + "static/media/rug-state-2.aba5e571.wav";